var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "terminal-order-table" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "header-cell-style": { textAlign: "center" },
            "cell-style": { textAlign: "center" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              prop: "outTradeNo",
              label: "订单编号",
              width: "200",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "transactionId",
              label: "商户单号",
              width: "200",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "appName",
              label: "来源渠道",
              width: "250",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "openId",
              label: "openid/设备ID",
              width: "180",
              align: "left",
              "header-align": "left",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "buyTypeName", label: "购买方式", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "goodsTypeName", label: "商品类型", width: "130" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "goodsName",
              label: "商品名称",
              width: "200",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "订单状态", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getOrderStatusTag(scope.row.status),
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.statusName) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "orderCreateTime",
              label: "下单时间",
              width: "180",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "goodsPrice",
              label: "商品价格(元)",
              width: "150",
              align: "right",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "goodsNum", label: "订单数量", align: "right" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "totalPayFee",
              label: "支付金额(元)",
              width: "150",
              align: "right",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "payTimeEnd",
              label: "支付时间",
              width: "180",
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.payTimeEnd || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "payTypeName", label: "支付方式" },
          }),
          _c("el-table-column", {
            attrs: { prop: "refundTime", label: "退款时间", width: "240" },
          }),
          _c("el-table-column", {
            attrs: { label: "退款状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.getRefundStatusDesc(scope.row.refundStatus)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "退款金额(元)", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(+scope.row.refundFee / 100) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "hotelInfo",
              label: "备注",
              width: "240",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.canRefund(scope.row)
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "TERMINAL_ORDER_REFUND",
                                expression: "'TERMINAL_ORDER_REFUND'",
                              },
                            ],
                            attrs: {
                              type: "text",
                              size: "small",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleRefund(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          申请退款\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }